<template>
    <div class="info-box-content">
      <div>
        <h1>SOLICITAR SER PROVEEDOR</h1>
        <h6>Complete el formulario</h6>
        <div class="back-btn">
          <el-button @click="goBackPage">&lt; Volver</el-button>
        </div>
      </div>
      <div>
        <!--Pagination-->
        <steps-pagination :activeStep="step" :isConfirmProvider="true"></steps-pagination>
      </div>
      <el-row>
        <el-col :span="24">
          <el-card class="box-card" v-if="step == 0">
            <template #header>
              <div class="card-header">
                <p>Datos generales</p>
              </div>
            </template>
            <!-- EDIT AND SAVE BUTTON -->
            <div style="display:flex;justify-content: start;">
              <el-button type="danger" v-if="!editing" @click="editing=true">Editar</el-button>
              <el-button type="success" v-if="editing" @click="modifyData('generalData')">Guardar</el-button>
              <el-button type="warning" v-if="editing" @click="editing=false">Cancelar</el-button>
            </div>
            <!--STEP 1-->
            <div style="width: 100%;margin-top:5rem;">
              <el-form
                ref="generalDataForm"
                v-if="step === 0"
                style="width: 80%; margin: auto;"
                label-width="200px"
              >
                <el-divider>Datos de la empresa</el-divider>
                <!--Alta RUC-->
                <alta-id
                  :idStatus="idStatus"
                  :type="idType"
                  :id="id"
                  :disabled="true"
                  v-on:validate-id="validateIDHandler"
                />
                <alta-form
                  :dataForm="generalData"
                  :locations="locations"
                  :validation="nextStepFlag"
                  :disabled="!editing"
                ></alta-form>
                <el-card
                  class="box-card"
                  v-if="
                    provider &&
                    provider.generalData.idCompanyDataStatus ===
                      status.DEVUELTO
                  "
                  style="margin-bottom: 15px"
                >
                  <div slot="header" class="clearfix">
                    <span style="font-weight:300;float:left">Observaciones</span>
                  </div>
                  <div class="text item" style="font-weight:300">
                    {{ provider.generalData.observation }}
                  </div>
                </el-card>
                <div
                  class="row text-center"
                  v-if="
                    provider &&
                    provider.generalData.idCompanyDataStatus === status.ESPERANDO_CONFIRMACION &&
                    !user.isProvider
                  "
                >
                  <el-divider> Aceptar datos </el-divider>
                  <el-button
                    type="danger"
                    @click="openRejectCompanyDataModal()"
                    data-cy="btn-rechazar"
                  >
                    Rechazar <i class="el-icon-close"></i
                  ></el-button>
                  <el-button
                    type="success"
                    @click="acceptCompanyData('generalData')"
                    data-cy="btn-aceptar"
                  >
                    Aceptar <i class="el-icon-check"></i
                  ></el-button>
                </div>
                <el-dialog
                  title="Rechazar datos"
                  :visible.sync="rejectCompanyDataVisible"
                  :fullscreen="false"
                  :lock-scroll="true"
                >
                Escriba el motivo por el cual rechaza los datos:
                <el-input
                  type="textarea"
                  :rows="4"
                  style="margin-top: 20px"
                  maxlength="400"
                  placeholder="Ingrese el motivo"
                  :show-word-limit="true"
                  v-model="newObservation"
                >
                </el-input>
                <span slot="footer" class="dialog-footer">
                  <el-button type="primary" v-on:click="rejectCompanyData('generalData')">
                  Aceptar
                  </el-button>
                </span>
              </el-dialog>
                <el-divider />
                <el-button
                  type="primary"
                  @click="nextStep"
                  style="float: left"
                >
                  Siguiente >
                </el-button>
              </el-form>
            </div>
            <div
              v-if="emailSoporte !== ''"
              class="email__consultas-container"
              style="margin-top: 100px"
            >
              <el-col :span="8" class="email__consultas"
                >Si tiene alguna duda o consulta técnica, por favor contactese
                con: <b>{{ emailSoporte }}</b></el-col
              >
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!--STEP 2-->
      <el-row>
        <el-col :span="24">
          <el-card class="box-card" v-if="step === 1">
            <template #header>
              <div class="card-header">
                <p>Datos Impositivos</p>
              </div>
            </template>
            <!-- EDIT AND SAVE BUTTON -->
            <div style="display:flex;justify-content: start;">
              <el-button type="danger" v-if="!editing" @click="editing=true">Editar</el-button>
              <el-button type="success" v-if="editing" @click="modifyData('taxData')">Guardar</el-button>
              <el-button type="warning" v-if="editing" @click="editing=false">Cancelar</el-button>
            </div>
            <p class="text-danger">
              Los campos acompañados con asterisco(*) son obligatorios
            </p>
            <div style="width: 100%">
              <el-form
                v-if="step == 1"
                style="width: 80%; margin: auto"
                label-width="200px"
              >
                <el-divider>Datos Impositivos</el-divider>
                <alta-form :dataForm="companyTaxData" :validation="nextStepFlag" :disabled="!editing"></alta-form>
                <!--v-if="companyData[2].model === true"-->
                <el-card
                  class="box-card"
                  v-if="
                    provider &&
                    provider.taxData.idCompanyDataStatus ===
                      status.DEVUELTO
                  "
                  style="margin-bottom: 15px"
                >
                  <div slot="header" class="clearfix">
                    <span style="font-weight:300;float:left">Observaciones</span>
                  </div>
                  <div class="text item" style="font-weight:300">
                    {{ provider.taxData.observation }}
                  </div>
                </el-card>
                <div
                  class="row text-center"
                  v-if="
                    provider &&
                    provider.taxData.idCompanyDataStatus === status.ESPERANDO_CONFIRMACION &&
                    !user.isProvider
                  "
                >
                  <el-divider> Aceptar datos </el-divider>
                  <el-button
                    type="danger"
                    @click="openRejectCompanyDataModal()"
                    data-cy="btn-rechazar"
                  >
                    Rechazar <i class="el-icon-close"></i
                  ></el-button>
                  <el-button
                    type="success"
                    @click="acceptCompanyData('taxData')"
                    data-cy="btn-aceptar"
                  >
                    Aceptar <i class="el-icon-check"></i
                  ></el-button>
                </div>
                <el-dialog
                  title="Rechazar datos"
                  :visible.sync="rejectCompanyDataVisible"
                  :fullscreen="false"
                  :lock-scroll="true"
                >
                Escriba el motivo por el cual rechaza los datos:
                <el-input
                  type="textarea"
                  :rows="4"
                  style="margin-top: 20px"
                  maxlength="400"
                  placeholder="Ingrese el motivo"
                  :show-word-limit="true"
                  v-model="newObservation"
                >
                </el-input>
                <span slot="footer" class="dialog-footer">
                  <el-button type="primary" v-on:click="rejectCompanyData('taxData')">
                  Aceptar
                  </el-button>
                </span>
              </el-dialog>
                <el-divider />
                <el-button-group style="float: left">
                  <el-button type="primary" @click="backStep">&lt; Anterior</el-button>
                  <el-button type="primary" @click="nextStep">Siguiente ></el-button>
                </el-button-group>
              </el-form>
            </div>
            <div
              v-if="emailSoporte !== ''"
              class="email__consultas-container"
              style="margin-top: 100px"
            >
              <el-col :span="8" class="email__consultas"
                >Si tiene alguna duda o consulta técnica, por favor contactese
                con: <b>{{ emailSoporte }}</b></el-col
              >
            </div>
          </el-card>
        </el-col>
      </el-row>



      <!--STEP 3-->
      <el-row>
        <el-col :span="24">
          <el-card class="box-card" v-if="step === 2">
            <template #header>
              <div class="card-header">
                <p>Datos Bancarios</p>
              </div>
            </template>
            <!-- EDIT AND SAVE BUTTON -->
            <div style="display:flex;justify-content: start;">
              <el-button type="danger" v-if="!editing" @click="editing=true">Editar</el-button>
              <el-button type="success" v-if="editing" @click="modifyData('paymentData')">Guardar</el-button>
              <el-button type="warning" v-if="editing" @click="editing=false">Cancelar</el-button>
            </div>
            <p class="text-danger">
              Los campos acompañados con asterisco(*) son obligatorios
            </p>
            <div style="width: 100%">
              <el-form
                v-if="step == 2"
                style="width: 80%; margin: auto"
                label-width="200px"
              >
                <el-divider>Datos Bancarios 1</el-divider>
                <alta-form :dataForm="paymentData1" :banks="banks" :bankAccountTypes="bankAccountTypes" :validation="nextStepFlag" :disabled="!editing"></alta-form>
                <el-divider>Datos Bancarios 2 (Opcional)</el-divider>
                <el-switch :disabled="!editing" v-model="optionalPaymentFlag.model" @change="clearOptionalPaymentData(optionalPaymentFlag.model)" active-text="Activar" inactive-text="Desactivar" style="margin-bottom:15px" />
                <alta-form :dataForm="paymentData2" :banks="banks" :bankAccountTypes="bankAccountTypes" :disabled="!optionalPaymentFlag.model || !editing" ></alta-form>
                <el-divider v-if="companyTaxData.detractionSwitch.model" />
                <div v-if="companyTaxData.detractionSwitch.model">
                  <h6>En caso de realizar actividades sujetas a detracción, por favor completar</h6>
                  <alta-form :dataForm="paymentData3" :validation="nextStepFlag" :disabled="!editing"></alta-form>
                </div>
                <el-card
                  class="box-card"
                  v-if="
                    provider &&
                    provider.paymentData.idCompanyDataStatus ===
                      status.DEVUELTO
                  "
                  style="margin-bottom: 15px"
                >
                  <div slot="header" class="clearfix">
                    <span style="font-weight:300;float:left">Observaciones</span>
                  </div>
                  <div class="text item" style="font-weight:300">
                    {{ provider.paymentData.observation }}
                  </div>
                </el-card>
                <div
                  class="row text-center"
                  v-if="
                    provider &&
                    provider.paymentData.idCompanyDataStatus === status.ESPERANDO_CONFIRMACION &&
                    !user.isProvider
                  "
                >
                  <el-divider> Aceptar datos </el-divider>
                  <el-button
                    type="danger"
                    @click="openRejectCompanyDataModal()"
                    data-cy="btn-rechazar"
                  >
                    Rechazar <i class="el-icon-close"></i
                  ></el-button>
                  <el-button
                    type="success"
                    @click="acceptCompanyData('paymentData')"
                    data-cy="btn-aceptar"
                  >
                    Aceptar <i class="el-icon-check"></i
                  ></el-button>
                </div>
                <el-dialog
                  title="Rechazar datos"
                  :visible.sync="rejectCompanyDataVisible"
                  :fullscreen="false"
                  :lock-scroll="true"
                >
                Escriba el motivo por el cual rechaza los datos:
                <el-input
                  type="textarea"
                  :rows="4"
                  style="margin-top: 20px"
                  maxlength="400"
                  placeholder="Ingrese el motivo"
                  :show-word-limit="true"
                  v-model="newObservation"
                >
                </el-input>
                <span slot="footer" class="dialog-footer">
                  <el-button type="primary" v-on:click="rejectCompanyData('paymentData')">
                  Aceptar
                  </el-button>
                </span>
              </el-dialog>
                <el-divider/>
                <el-button-group style="float: left">
                <el-button type="primary" @click="backStep">&lt; Anterior</el-button>
                <el-button type="primary" @click="nextStep" v-if="step <= 1">Siguiente ></el-button>
                </el-button-group>
              </el-form>
            </div>
            <div
              v-if="emailSoporte !== ''"
              class="email__consultas-container"
              style="margin-top: 100px"
            >
              <el-col :span="8" class="email__consultas"
                >Si tiene alguna duda o consulta técnica, por favor contactese
                con: <b>{{ emailSoporte }}</b></el-col
              >
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!-- STEP 4 -->
      <el-row v-if="step == 3">
        <el-col :span="24">
          <el-card class="box-card">
            <template #header>
              <div class="card-header">
                <p>Usuario</p>
              </div>
            </template>
            <p class="text-danger">
              Los campos acompañados con asterisco(*) son obligatorios
            </p>
            <div style="width: 100%">
              <el-form style="width: 80%; margin: auto" label-width="200px">
                <alta-form :dataForm="userData" :validation="nextStepFlag"></alta-form>
                <p
                style="color: #a94442;"
                v-if="this.response"
                >
                {{ this.response }}
                </p>
                <el-divider />
                <el-button-group style="float: left" v-if="validateRuc">
                  <el-button type="primary" @click="backStep">&lt; Anterior</el-button>
                  <el-button type="success" @click="openModalTerminosYCondiciones">Confirmar</el-button>
                </el-button-group>
              </el-form>
            </div>
            <div
              v-if="emailSoporte !== ''"
              class="email__consultas-container"
              style="margin-top: 100px"
            >
              <el-col :span="8" class="email__consultas"
                >Si tiene alguna duda o consulta técnica, por favor contactese
                con: <b>{{ emailSoporte }}</b></el-col
              >
            </div>
          </el-card>
        </el-col>
        <!-- MODAL TERMINOS Y CONDICIONES -->
        <el-dialog
        title="Confirmar Alta de Proveedor"
        :visible.sync="showTerminosYCondiciones"
        width="80%"
        style="margin-top: -12vh; height: auto; overflow-y: hidden"
        :lock-scroll="true"
        >
          <div style="max-height: 60vh; overflow: auto">
            <p>{{ configuration }}</p>
            <br /><br />
          </div>
          <form @submit.prevent="">
            <div style="display: flex;">
              <input
                type="checkbox"
                name="aceptoCodigoEtica"
                required
                style="width: 15px; margin: 0 5px 0 0; padding-bottom: 5px;"
               v-model="checked2"
              />
              <p style="margin:0">Acepto el
                <a target="_blank" style="cursor:pointer" rel="noopener noreferrer" :href="codigoEtica"
                  >Código de Ética y Conducta
                </a>.
              </p>
            </div>
            <div style="display:flex;">
              <input
                type="checkbox"
                name="aceptoTerminos"
                required
                style="width: 15px; margin: 0 5px 0 0"
                v-model="checked"
              />
              <p style="margin:0">
                Acepto las políticas:
                <a
                  style="cursor:pointer"
                  target="_blank"
                  rel="noopener noreferrer"
                  :href="politicaAnticorrupcion"
                  >Política Anticorrupción</a
                >
                y
                <a
                  style="cursor:pointer"
                  target="_blank"
                  rel="noopener noreferrer"
                  :href="politicaRelacionamiento"
                  >Política de Relacionamiento con Funcionarios Públicos.</a
                >
              </p>
            </div>
            <span slot="footer" class="dialog-footer">
            <button
              type="submit"
              v-on:click="submitFormSolicitud()"
              :disabled="!checked2 || !checked"
              v-bind:class="'btn btn-primary btn-lg ' + loading"
            >
            Aceptar
            </button>
            </span>
          </form>
        </el-dialog>
      </el-row>
    </div>
</template>
<script>
import mySteps from './MySteps.vue'
import AltaID from './AltaID.vue'
import { mapState } from 'vuex'
import AltaForm from './AltaFormElements.vue'
import { persistToNewProviderStorage, saveDataToLocalStorage } from '../helpers/utils.js'
import api from '../../api'
import stage from '../../config/company_stage'
import rolesText from '../../config/roles'
import status from '../../config/data_status'
export default {
  components: {
    'steps-pagination': mySteps,
    'alta-id': AltaID,
    'alta-form': AltaForm
  },
  computed: {
    ...mapState([
      'user'
    ])
  },
  data () {
    return {
      idType: 'RUC',
      status: status,
      countryId: 256,
      response: null,
      rejectCompanyDataVisible: false,
      newObservation: '',
      success: null,
      loading: '',
      editing: false,
      savedGeneralData: '',
      savedPaymentData: '',
      savedTaxData: '',
      userByRoles: false,
      userIsAdmin: false,
      generalDataAccepted: false,
      paymentDataAccepted: false,
      taxDataAccepted: false,
      generalDataRejected: false,
      paymentDataRejected: false,
      taxDataRejected: false,
      savedUserData: '',
      codCountry: 'PE',
      id: {model: '', dataType: 'ID'},
      emailSoporte: 'soporte@albanesi.com.ar',
      step: 1,
      optionalPaymentFlag: {model: false, dataType: 'flag'},
      nextStepFlag: true,
      idStatus: 'accept',
      validateRuc: false,
      emptyFields: [],
      showTerminosYCondiciones: false,
      codigoEtica: '',
      politicaAnticorrupcion: '',
      politicaRelacionamiento: '',
      checked: false,
      checked2: false,
      provider: null,
      idCompany: this.$route.params.id,
      actualCountry: this.$route.params.country,
      idStep: this.$route.params.step,
      providerLoaded: false,
      locations: [],
      banks: [],
      bankAccountTypes: [],
      generalData: {
        company: {
          name: 'company',
          dataType: 'input',
          label: 'Razón Social / Denominación*',
          model: '',
          required: true
        },
        companyName: {
          name: 'companyName',
          dataType: 'input',
          label: 'Nombre comercial',
          model: '',
          required: false
        },
        activityField: {
          name: 'activityField',
          dataType: 'select',
          label: 'Campo de Actividad*',
          model: '',
          optionValue: [],
          placeholder: 'Seleccionar el Campo de actividad',
          required: true
        },
        country: {
          name: 'country',
          dataType: 'select',
          label: 'País*',
          model: 'Perú',
          optionValue: ['Perú'],
          placeholder: 'Seleccionar País',
          required: true
        },
        location: {
          name: 'location',
          dataType: 'select',
          label: 'Localidad*',
          model: '',
          optionValue: [],
          placeholder: 'Seleccionar Localidad',
          required: true
        },
        city: {
          name: 'city',
          dataType: 'input',
          label: 'Ciudad*',
          model: '',
          required: true
        },
        address: {
          name: 'address',
          name2: 'addressNumber',
          dataType: 'input-double',
          label: 'Calle*',
          label2: 'N°',
          model: '',
          model2: '',
          required: true
        },
        zip: {
          name: 'zip',
          dataType: 'input',
          label: 'Código Postal*',
          type: 'number',
          model: '',
          required: true
        },
        phone: {
          name: 'phone',
          dataType: 'input',
          label: 'Telefono*',
          type: 'number',
          model: '',
          required: true
        },
        email: {
          name: 'email',
          dataType: 'input',
          label: 'Email*',
          type: 'email',
          validate: 'email',
          model: '',
          required: true
        },
        pdfRuc: {
          name: 'pdfRuc',
          dataType: 'upload',
          label: 'Constancia de inscripcion RUC - Ficha RUC*',
          model: '',
          required: true
        }
      },
      paymentData1: {
        pdfPayment: {
          name: 'pdfPayment',
          dataType: 'upload',
          label: 'Instrucciones para acreditación de pagos*',
          model: '',
          required: true // luego sera true
        },
        bank: {
          name: 'bank',
          dataType: 'select',
          label: 'Banco*',
          model: '',
          optionValue: [],
          placeholder: 'Seleccionar Banco',
          required: true
        },
        bankAccount: {
          name: 'bankAccount',
          dataType: 'input',
          label: 'Nro de Cuenta*',
          validate: 'onlyNumbers',
          max: 11,
          model: '',
          required: true
        },
        accountType: {
          name: 'accountType',
          dataType: 'select',
          label: 'Tipo*',
          model: '',
          optionValue: '',
          placeholder: 'Seleccionar Tipo',
          required: true
        },
        currency: {
          name: 'currency',
          dataType: 'select',
          label: 'Moneda*',
          model: 'PEN',
          optionValue: ['PEN'],
          placeholder: 'Seleccionar Moneda',
          required: true
        },
        cciNumber: {
          name: 'cciNumber',
          dataType: 'input',
          label: 'Nro CCI*',
          max: 20,
          model: '',
          validate: 'onlyNumbers',
          required: true
        }
      },
      paymentData2: {
        bank2: {
          name: 'bank2',
          dataType: 'select',
          label: 'Banco',
          model: '',
          optionValue: [],
          placeholder: 'Seleccionar Banco',
          required: true
        },
        bankAccount2: {
          name: 'bankAccount2',
          dataType: 'input',
          label: 'Nro de Cuenta',
          max: 11,
          validate: 'onlyNumbers',
          model: '',
          required: true
        },
        accountType2: {
          name: 'accountType2',
          dataType: 'select',
          label: 'Tipo',
          model: '',
          optionValue: '',
          placeholder: 'Seleccionar Tipo',
          required: true
        },
        currency2: {
          name: 'currency2',
          dataType: 'select',
          label: 'Moneda',
          model: '',
          optionValue: ['PEN'],
          placeholder: 'Seleccionar Moneda',
          required: true
        },
        cciNumber2: {
          name: 'cciNumber2',
          dataType: 'input',
          label: 'Nro CCI',
          validate: 'onlyNumbers',
          max: 20,
          model: '',
          required: true
        }
      },
      paymentData3: {
        detractionBank: {
          name: 'detractionBank',
          dataType: 'input',
          label: 'Nro de Cuenta del Banco Nación*',
          max: 11,
          validate: 'onlyNumbers',
          model: '',
          required: true
        }
      },
      companyTaxData: {
        register: {
          name: 'register',
          dataType: 'input',
          label: 'Partida Registral',
          model: '',
          required: true
        },
        paymentType: {
          name: 'paymentType',
          dataType: 'select',
          label: 'Tipo de comprobantes a emitir',
          model: '',
          optionValue: ['Factura', 'ND', 'NC', 'RC por honorarios', 'Giros de remision'],
          placeholder: 'Seleccionar el tipo de comprobante',
          required: true
        },
        perceptionSwitch: {
          name: 'perceptionSwitch',
          dataType: 'switch-perception',
          label: 'Su empresa es agente de percepción?',
          model: false,
          companyDataPerception: {
            name: 'companyDataPerception',
            label: 'Alícuota*',
            model: '',
            required: true
          }
        },
        retentionSwitch: {
          name: 'retentionSwitch',
          dataType: 'switch-retention',
          label: 'Su empresa es agente de retención?',
          model: false,
          companyDataRetention: {
            name: 'companyDataRetention',
            label: 'Denominación*',
            model: '',
            optionValue: [],
            placeholder: 'Seleccionar el tipo de Denominación',
            required: true
          },
          companyRetentionFields: {
            name: 'companyRetentionFields',
            label: 'Alícuota*',
            model: '',
            placeholder: 'Seleccionar alicuota',
            required: true
          },
          companySuspensionNumber: {
            name: 'companySuspensionNumber',
            label: 'Número*',
            model: '',
            type: 'number',
            required: true
          },
          firstDate: {
            name: 'firstDate',
            model: '',
            required: true
          },
          lastDate: {
            name: 'lastDate',
            model: '',
            required: true
          },
          pdfSuspension: {
            name: 'pdfSuspension',
            model: '',
            label: 'Certificado de suspensión*',
            required: true
          }
        },
        detractionSwitch: {
          name: 'detractionSwitch',
          dataType: 'switch-detraction',
          label: 'Su empresa realiza actividades sujetas a detracción?',
          model: false
        }
      },
      userData: {
        userName: {
          name: 'name',
          dataType: 'input',
          label: 'Nombre y apellido',
          model: '',
          required: true
        },
        email: {
          name: 'email',
          dataType: 'input',
          label: 'Email',
          validate: 'email',
          model: '',
          required: true
        },
        password: {
          name: 'password',
          dataType: 'input',
          label: 'Contraseña',
          type: 'password',
          validate: 'password',
          model: '',
          required: true
        },
        repeatedPassword: {
          dataType: 'input',
          label: 'Repetir Contraseña',
          type: 'password',
          model: '',
          validate: 'repeated-password',
          samePassword: false,
          required: true
        }
      }
    }
  },
  watch: {
    provider: {
      immediate: true,
      handler (val) {
        this.loadProvider()
      }
    }
  },
  methods: {
    companyData () {
      if (this.idCompany) {
        let that = this
        api
          .request(
            'GET',
            'api/ListCompanyData' + '?idCompany=' + this.idCompany + '&actualCountry=' + this.actualCountry
          )
          .then((response) => {
            var data = response.data
            if (data.error) {
              return
            }
            if (data) {
              that.providers = data
              that.provider = that.providers[0]
            }
          })
          .catch((error) => {
            that.$store.commit('TOGGLE_LOADING')
            console.log(error)
          })
      }
    },
    isSystemAdmin () {
      if (this.user) {
        this.user.roles.forEach((role) => {
          if (role.rolesId === rolesText.ADMIN_SISTEMA) {
            this.userIsAdmin = true
          }
          if (
            role.rolesId === rolesText.AUTORIZADOR_DG_PE ||
            role.rolesId === rolesText.AUTORIZADOR_DI_PE ||
            role.rolesId === rolesText.AUTORIZADOR_DP_PE
          ) {
            this.userByRoles = true
          }
        })
      }
    },
    loadProvider () {
      if (this.provider) {
        this.step = this.provider.idStage - 1
        // STEP 1
        this.providerLoaded = true
        this.id.model = this.provider.fiscalId
        this.generalData.company.model = this.provider.generalData.company
        this.generalData.companyName.model = this.provider.generalData.companyName
        this.generalData.activityField.model = this.provider.generalData.activityField
        this.generalData.location.model = this.provider.generalData.location
        // this.generalData.location.model = this.locations.data.find((location) => location.idProvince === this.provider.generalData.location).codRegion
        this.generalData.city.model = this.provider.generalData.city
        this.generalData.address.model = this.provider.generalData.address
        this.generalData.address.model2 = this.provider.generalData.addressNumber
        this.generalData.zip.model = this.provider.generalData.zip
        this.generalData.phone.model = this.provider.generalData.phone
        this.generalData.email.model = this.provider.generalData.email
        this.generalData.pdfRuc.model = this.provider.generalData.pdfRuc
        // STEP 2
        this.companyTaxData.register.model = this.provider.taxData.register
        this.companyTaxData.paymentType.model = this.provider.taxData.paymentType
        this.companyTaxData.perceptionSwitch.model = this.provider.taxData.perceptionSwitch
        this.companyTaxData.perceptionSwitch.companyDataPerception.model = this.provider.taxData.companyDataPerception
        this.companyTaxData.retentionSwitch.model = this.provider.taxData.retentionSwitch
        this.companyTaxData.retentionSwitch.companyDataRetention.model = this.provider.taxData.companyDataRetention
        this.companyTaxData.retentionSwitch.companyRetentionFields.model = this.provider.taxData.companyRetentionFields
        this.companyTaxData.retentionSwitch.companySuspensionNumber.model = this.provider.taxData.companySuspensionNumber
        this.companyTaxData.retentionSwitch.firstDate.model = this.provider.taxData.firstDate
        this.companyTaxData.retentionSwitch.lastDate.model = this.provider.taxData.lastDate
        this.companyTaxData.retentionSwitch.pdfSuspension.model = this.provider.taxData.pdfSuspension
        this.companyTaxData.detractionSwitch.model = this.provider.taxData.detractionSwitch
        // STEP 3
        this.paymentData1.pdfPayment.model = this.provider.paymentData.pdfPayment
        this.paymentData1.bank.model = this.provider.paymentData.bank
        this.paymentData1.bankAccount.model = this.provider.paymentData.bankAccount
        this.paymentData1.accountType.model = this.provider.paymentData.accountType
        this.paymentData1.cciNumber.model = this.provider.paymentData.cciNumber
        this.paymentData2.bank2.model = this.provider.paymentData.bank2
        this.paymentData2.bankAccount2.model = this.provider.paymentData.bankAccount2
        this.paymentData2.accountType2.model = this.provider.paymentData.accountType2
        this.paymentData2.currency2.model = this.provider.paymentData.currency2
        this.paymentData2.cciNumber2.model = this.provider.paymentData.cciNumber2
        this.paymentData3.detractionBank.model = this.provider.paymentData.detractionBank
      }
    },
    persistToNewProviderStorage,
    saveDataToLocalStorage,
    validateSteps () {
      this.emptyFields = []
      if (this.nextStepFlag === false && this.step === 0) {
        // VALIDATE GENERAL DATA
        this.validateData(this.generalData)
      }
      if (this.nextStepFlag === false && this.step === 1) {
        this.validateCompanyTaxData()
        this.validateData(this.companyTaxData)
      }
      if (this.nextStepFlag === false && this.step === 2) {
        // VALIDATE PAYMENT DATA
        this.validateData(this.paymentData1)
        if (this.optionalPaymentFlag.model) {
          this.validateData(this.paymentData2)
        }
        if (this.companyTaxData.detractionSwitch.model) {
          this.validateData(this.paymentData3)
        }
      }
      if (this.step === 3) {
        // VALIDATE USER DATA
        this.validateData(this.userData)
      }
      console.log(this.emptyFields)
    },
    nextStep () {
      this.nextStepFlag = false
      this.validateSteps()
      if (this.nextStepFlag === false) {
        return
      }
      if (this.step++ >= 3) {
        this.step = 0
        this.validateRuc = false
      }
    },
    backStep () {
      this.nextStepFlag = false
      const actualStep = this.step
      this.step = actualStep - 1
    },
    goBackPage () {
      window.history.back()
    },
    validateIDHandler (id) {
      this.id = id
      if (id !== '' && this.idStatus === 'accept') {
        this.idStatus = 'edit'
        this.verifyRuc(id.model)
      } else if (this.idStatus === 'edit') {
        this.idStatus = 'accept'
        this.validateRuc = false
      }
    },
    validateData (stepData) {
      for (const key in stepData) {
        const data = stepData[key]
        // VALIDA EL EMAIL SI ES QUE ALGUN CAMPO TIENE EMAIL
        this.validateEmail(data)
        // VALIDA SI ALGUN CAMPO NECESITA SER SOLO NUMERICO CON MAXIMOS Y MINIMOS
        this.validateNumbers(data)
        // VALIDA SI LAS CONTRASEÑAS SON IGUALES EN CASO DE TENER ESTOS CAMPOS
        this.validatePasswords(data)
        // valida que el campo no esta vacio
        if (data.required && (data.model === '' || data.model2 === '')) {
          this.emptyFields.push(data.label)
          this.nextStepFlag = false
        }
      }
      if (this.emptyFields.length === 0 && this.step < 3) {
        this.nextStepFlag = true
      }
    },
    validateEmail (data) {
      if (data.validate === 'email') {
        const regex = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/
        if (!regex.test(data.model)) {
          this.nextStepFlag = false
          this.emptyFields.push(data.label)
        }
      }
    },
    validateNumbers (data) {
      if (data.validate === 'onlyNumbers') {
        const regex = /^[0-9]+$/
        if (!regex.test(data.model) || data.model.length < data.max) {
          this.nextStepFlag = false
          this.emptyFields.push(data.label)
        }
      }
    },
    validatePasswords (data) {
      if (data.validate === 'password' && data.model !== this.userData.repeatedPassword.model) {
        this.userData.repeatedPassword.samePassword = false
        this.nextStepFlag = false
        this.emptyFields.push(data.label)
      } else if (data.validate === 'password' && data.model === this.userData.repeatedPassword.model) {
        this.userData.repeatedPassword.samePassword = true
      }
    },
    validateCompanyTaxData () {
      const { perceptionSwitch, retentionSwitch } = this.companyTaxData
      const { companyDataRetention, companyRetentionFields, firstDate, lastDate, pdfSuspension, companySuspensionNumber } = retentionSwitch
      if (perceptionSwitch.model && !perceptionSwitch.companyDataPerception.model) {
        this.emptyFields.push(perceptionSwitch.companyDataPerception.label)
        this.nextStepFlag = false
      }
      if (retentionSwitch.model) {
        if (!companyDataRetention.model.length) {
          this.emptyFields.push(companyDataRetention.label)
          this.nextStepFlag = false
        }
        if (!companyRetentionFields.model.length) {
          this.emptyFields.push(companyRetentionFields.label)
          this.nextStepFlag = false
        }
        if (companyDataRetention.model.includes('Retencion Detracciones') && (!firstDate.model || !lastDate.model || !pdfSuspension.model || !companySuspensionNumber.model)) {
          this.emptyFields.push(companyDataRetention.label)
          this.nextStepFlag = false
        }
      }
      if (!this.emptyFields.length) {
        this.nextStepFlag = true
      }
    },
    recoverFromNewProviderStorage (inputType = {}, inputId) {
      const newProvider = JSON.parse(localStorage.getItem('newProviderPeru'))
      if (!newProvider) {
        return {}
      }
      const data = newProvider[inputId]
      if (!data) {
        return {}
      }
      if (inputType['dataType'] === 'ID' || inputType['dataType'] === 'flag') {
        inputType['model'] = data
      }
      const input = inputType[inputId]
      if (!input) {
        return data
      }
      const {dataType} = input
      if (['input', 'select', 'upload', 'switch-detraction'].includes(dataType)) {
        input.model = data
      }
      if (dataType === 'input-double') {
        input.model = data
        input.model2 = data
      }
      if (dataType === 'switch-perception') {
        input.model = data
        input.companyDataPerception.model = newProvider.companyDataPerception
      }
      if (dataType === 'switch-retention') {
        inputType[inputId].model = data
        Object.values(input).forEach((value) => {
          if (typeof value === 'object') {
            value.model = newProvider[value.name]
          }
        })
      }
      return data
    },
    checkData () {
      this.toggleLoading()
      this.resetResponse()
      this.manageDataObjects()
      this.$store.commit('TOGGLE_LOADING')
      /* Making API call to authenticate a user */
      // api.request('GET', 'api/solicitudUsuario' + '?rut=' + rut + '&invoice0=' + invoice0 + '&date0=' + date0 + '&invoice1=' + invoice1 + '&date1=' + date1 + '&invoice2=' + invoice2 + '&date2=' + date2 + '&name=' + name + '&reason=' + reason + '&email=' + email)
      let url = 'api/saveNewProvider'
      let url2 = '/login'
      if (this.user) {
        url = 'api/saveNewProviderRegister'
        url2 = '/providers'
      }
      api
        .request('POST', url, {
          generalData: this.savedGeneralData,
          paymentData: this.savedPaymentData,
          taxData: this.savedTaxData,
          userData: this.savedUserData
        })
        .then((response) => {
          this.toggleLoading()
          var data = response.data
          /* Checking if error object was returned from the server */
          if (response.data.error) {
            var errorName = response.data.error.name
            if (errorName) {
              console.log(errorName)
              this.checked = false
              this.checked2 = false
              if (errorName === 'InvalidArgumentError') {
                this.response = 'Los datos son incorrectos.'
              } else if (errorName === 'NotFoundError') {
                this.response = 'Se ha producido un error inesperado.'
              } else {
                this.response = errorName
              }
            } else {
              this.response = data.error
            }

            return
          } else {
            if (data.success) {
              // api.request('GET', 'api/sendMailSignUp/' + response.data.idUser)
              // .then(response => {
              // })
              api
                .request('POST', 'api/sendSignUpMessage', {
                  idEmisor: 1,
                  idReceptor: response.data.idUser,
                  message:
                    'Gracias por registrarse, Estamos revisando la información remitida',
                  messageType: 1
                })
                .then((response) => {})
              this.$alert(
                'Sus datos se han remitido correctamente, muchas gracias!',
                'Información Enviada',
                {
                  confirmButtonText: 'Confirmar',
                  callback: (action) => {
                    this.$router.push(url2)
                  }
                }
              )
              this.success = data.success
            }
          }
        })
        .catch((error) => {
          this.$store.commit('TOGGLE_LOADING')
          this.invoices = null
          console.log(error.response)
          this.response = 'Se ha producido un error, verifique los datos, en caso de persisitir, comuniquese con soporte.'
          if (error.response.data) {
            let err = Object.keys(error.response.data)[0]
            this.response = error.response.data[err][0]
          }
          console.log(this.response)
          this.toggleLoading()
        })
    },
    toggleLoading () {
      this.loading = this.loading === '' ? 'cargando' : ''
    },
    resetResponse () {
      this.response = ''
      this.success = ''
    },
    extractFieldValues (data, enabled = true) {
      const extractedData = {}
      for (const key in data) {
        if (enabled) {
          if (data.hasOwnProperty(key)) {
            extractedData[data[key].name] = data[key].model
          }
        }
        if (!enabled) {
          if (data.hasOwnProperty(key)) {
            extractedData[data[key].name] = ''
          }
        }
      }
      return extractedData
    },
    manageDataObjects () {
      // GeneralData
      let generalData = { ...this.extractFieldValues(this.generalData) }
      generalData['ruc'] = this.id.model
      generalData[`${this.generalData.address.name2}`] = this.generalData.address.model2

      // PaymentData
      let paymentData = { ...this.extractFieldValues(this.paymentData1) }
      if (this.optionalPaymentFlag.model) {
        paymentData = { ...paymentData, ...this.extractFieldValues(this.paymentData2) }
      } else {
        paymentData = { ...paymentData, ...this.extractFieldValues(this.paymentData2, false) }
      }
      if (this.companyTaxData.detractionSwitch.model) {
        paymentData = { ...paymentData, ...this.extractFieldValues(this.paymentData3) }
      } else {
        paymentData = { ...paymentData, ...this.extractFieldValues(this.paymentData3, false) }
      }

      // TaxData
      const taxData = { ...this.extractFieldValues(this.companyTaxData) }
      if (this.companyTaxData.perceptionSwitch.model) {
        taxData[`${this.companyTaxData.perceptionSwitch.companyDataPerception.name}`] = this.companyTaxData.perceptionSwitch.companyDataPerception.model
      } else {
        taxData[`${this.companyTaxData.perceptionSwitch.companyDataPerception.name}`] = ''
      }
      if (this.companyTaxData.retentionSwitch.model) {
        taxData[`${this.companyTaxData.retentionSwitch.companyDataRetention.name}`] = this.companyTaxData.retentionSwitch.companyDataRetention.model
        taxData[`${this.companyTaxData.retentionSwitch.companyRetentionFields.name}`] = this.companyTaxData.retentionSwitch.companyRetentionFields.model
        taxData[`${this.companyTaxData.retentionSwitch.companySuspensionNumber.name}`] = this.companyTaxData.retentionSwitch.companySuspensionNumber.model
        taxData[`${this.companyTaxData.retentionSwitch.firstDate.name}`] = this.companyTaxData.retentionSwitch.firstDate.model
        taxData[`${this.companyTaxData.retentionSwitch.lastDate.name}`] = this.companyTaxData.retentionSwitch.lastDate.model
        taxData[`${this.companyTaxData.retentionSwitch.pdfSuspension.name}`] = this.companyTaxData.retentionSwitch.pdfSuspension.model
      } else {
        taxData[`${this.companyTaxData.retentionSwitch.companyDataRetention.name}`] = ''
        taxData[`${this.companyTaxData.retentionSwitch.companyRetentionFields.name}`] = ''
        taxData[`${this.companyTaxData.retentionSwitch.companySuspensionNumber.name}`] = ''
        taxData[`${this.companyTaxData.retentionSwitch.firstDate.name}`] = ''
        taxData[`${this.companyTaxData.retentionSwitch.lastDate.name}`] = ''
        taxData[`${this.companyTaxData.retentionSwitch.pdfSuspension.name}`] = ''
      }
      // UserData
      const userData = { ...this.extractFieldValues(this.userData) }

      // Save data
      this.savedGeneralData = generalData
      this.savedTaxData = taxData
      this.savedPaymentData = paymentData
      this.savedUserData = userData
    },
    getLocations () {
      api.request('GET', `api/getProvincesByCountry?countryId=${this.countryId}`)
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.locations = data
            data.data.forEach((location) => {
              this.generalData.location.optionValue.push(location.codRegion)
            })
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getRubros () {
      api.request('GET', `api/getRubrosPeru`)
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            data.data.forEach((activity) => {
              this.generalData.activityField.optionValue.push(activity.activity)
            })
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getDenomination () {
      api.request('GET', `api/getRetentionRegimenCountry?codCountry=${this.codCountry}`)
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            data.data.forEach((regime) => {
              this.companyTaxData.retentionSwitch.companyDataRetention.optionValue.push({'retentionRegime': regime.retentionRegime, 'idRetentionRegime': regime.idRetentionRegime})
            })
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    getBank () {
      api.request('GET', `api/getBankByCountry?codCountry=${this.codCountry}`)
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            console.log('banks', data)
            this.banks = data
            data.data.forEach((bankData) => {
              this.paymentData1.bank.optionValue.push(bankData.bank)
              this.paymentData2.bank2.optionValue.push(bankData.bank)
            })
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    verifyRuc (ruc) {
      const cachedData = JSON.parse(localStorage.getItem('newProvider'))
      // this.$refs['generalDataForm'].validateField('id', (valid) => {
      //   if (!valid) {
      this.$store.commit('START_LOADING')
      api
        .request('GET', 'api/getPersonaSunat/' + ruc)
        .then((response) => {
          // console.log(response)
          if (typeof response.data === 'string') {
            this.dataAfip = ''
            this.$message({
              message: response.data.replace('Id', 'RUC'),
              type: 'warning'
            })
          } else {
            this.validateRuc = true
            if (!response.data.errorConstancia) {
              this.dataAfip = response.data.datosGenerales
              if (this.dataAfip.tipoPersona === 'JURIDICA') {
                this.generalData.company = this.dataAfip.razonSocial
              } else if (!cachedData.company) {
                this.generalData.company =
                  (this.dataAfip.nombre ? this.dataAfip.nombre + ' ' : '') +
                  this.dataAfip.apellido
              }
              api
                .request(
                  'GET',
                  'api/allCertification/' + this.generalData.cuit
                )
                .then((response) => {
                  // console.log('CERTIFICADOS')
                  // console.log(response.data['exgainCertification'])
                  if (response.data['exgainCertification'].length === 0) {
                    // this.certificationExgainList = response.data['exgainCertification']
                    this.auxFlagEmptyExgainList = true
                    // console.log(this.auxFlagEmptyExgainList)
                  }
                  this.certificationExgainList =
                    response.data['exgainCertification']
                  // this.$store.state.allCertification = response.data['exgainCertification']
                  // console.log('STORE')
                  // console.log(this.$store.state.allCertification)
                  // this.certificationExgainList.push({'IdCertificationExGain': certif.IdCertificationExGain, 'number': certif.number, 'publication': certif.publication, 'validity': certif.validity})
                  this.certificationSussList =
                    response.data['sussCertification']
                  this.certificationRg18List =
                    response.data['rg18Certification']
                  this.certificationRg17List =
                    response.data['rg17Certification']
                  this.certificationRg2681List =
                    response.data['rg2681Certification']
                })
              this.$message({
                message: 'RUC verificado correctamente en SUNAT',
                type: 'success'
              })
            } else {
              let mensaje = ''
              if (typeof response.data.errorConstancia.error === 'string') {
                mensaje = response.data.errorConstancia.error
              } else {
                mensaje = response.data.errorConstancia.error.join('\n')
              }
              this.$message({
                message: 'Informa SUNAT: \n' + mensaje,
                type: 'error'
              })
            }
          }
          this.$store.commit('STOP_LOADING')
        })
        .catch((error) => {
          this.$store.commit('STOP_LOADING')
          if (error && error.response && error.response.status === '400') {
            this.$message({
              message: error.response.data,
              type: 'error'
            })
          } else {
            this.$message.error('Error conectando con el servidor')
          }
        })
      //   }
      // })
    },
    modifyData (dataType) {
      this.$confirm(
      'Sus Datos se remitirán a Albanesi para su verificación',
      'Atención',
        {
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }
      ).then(() => {
        this.editing = false
        this.provider.idCompanyDataStatus = status.MODIFICADO
        this.saveData(dataType)
      })
    },
    saveData (dataType) {
      let generalData = {}
      let paymentData = {}
      let taxData = {}
      if (dataType === 'generalData') {
        generalData = { ...this.extractFieldValues(this.generalData) }
        generalData[`${this.generalData.address.name2}`] = this.generalData.address.model2
        this.updateCompanyData(dataType, generalData)
      }
      if (dataType === 'paymentData') {
        paymentData = { ...this.extractFieldValues(this.paymentData1) }
        if (this.optionalPaymentFlag.model) {
          paymentData = { ...paymentData, ...this.extractFieldValues(this.paymentData2) }
        } else {
          paymentData = { ...paymentData, ...this.extractFieldValues(this.paymentData2, false) }
        }
        if (this.companyTaxData.detractionSwitch.model) {
          paymentData = { ...paymentData, ...this.extractFieldValues(this.paymentData3) }
        } else {
          paymentData = { ...paymentData, ...this.extractFieldValues(this.paymentData3, false) }
        }
        this.updateCompanyData(dataType, paymentData)
      }
      if (dataType === 'taxData') {
        taxData = { ...this.extractFieldValues(this.companyTaxData) }
        taxData[`${this.companyTaxData.perceptionSwitch.companyDataPerception.name}`] = this.companyTaxData.perceptionSwitch.companyDataPerception.model
        if (this.companyTaxData.perceptionSwitch.model) {
        } else {
          taxData[`${this.companyTaxData.perceptionSwitch.companyDataPerception.name}`] = ''
        }
        if (this.companyTaxData.retentionSwitch.model) {
          taxData[`${this.companyTaxData.retentionSwitch.companyDataRetention.name}`] = this.companyTaxData.retentionSwitch.companyDataRetention.model
          taxData[`${this.companyTaxData.retentionSwitch.companyRetentionFields.name}`] = this.companyTaxData.retentionSwitch.companyRetentionFields.model
          taxData[`${this.companyTaxData.retentionSwitch.companySuspensionNumber.name}`] = this.companyTaxData.retentionSwitch.companySuspensionNumber.model
          taxData[`${this.companyTaxData.retentionSwitch.firstDate.name}`] = this.companyTaxData.retentionSwitch.firstDate.model
          taxData[`${this.companyTaxData.retentionSwitch.lastDate.name}`] = this.companyTaxData.retentionSwitch.lastDate.model
          taxData[`${this.companyTaxData.retentionSwitch.pdfSuspension.name}`] = this.companyTaxData.retentionSwitch.pdfSuspension.model
        } else {
          taxData[`${this.companyTaxData.retentionSwitch.companyDataRetention.name}`] = ''
          taxData[`${this.companyTaxData.retentionSwitch.companyRetentionFields.name}`] = ''
          taxData[`${this.companyTaxData.retentionSwitch.companySuspensionNumber.name}`] = ''
          taxData[`${this.companyTaxData.retentionSwitch.firstDate.name}`] = ''
          taxData[`${this.companyTaxData.retentionSwitch.lastDate.name}`] = ''
          taxData[`${this.companyTaxData.retentionSwitch.pdfSuspension.name}`] = ''
        }
        this.updateCompanyData(dataType, taxData)
      }
    },
    updateCompanyData (dataType, data) {
      // Condiciones simples para asignar el idCompanyCompanyDataStatusole.log(status.ESPERANDO_CONFIRMACION)
      // this.activationOrReject()
      // Condiciones simples para asignar el idStage

      if (this.generalDataAccepted) {
        data.idCompanyDataStatus = status.ACEPTADO
        data.idUser = this.user.idUser
        this.provider.idStage = stage.DATOS_BANCARIOS
        this.provider.idUser = this.user.idUser
      }
      if (this.generalDataRejected) {
        data.idCompanyDataStatus = status.DEVUELTO
        this.provider.idStage = stage.DATOS_BANCARIOS
        this.provider.idCompanyDataStatus = status.DEVUELTO
        this.provider.idUser = this.user.idUser
        data.observation = this.newObservation
        data.idUser = this.user.idUser
        setTimeout(() => {
          api
            .request('GET', 'api/sendMailUserReject/' + this.provider.idCompany + '?codCountry=' + 'PE')
            .then(() => {})
        }, 900)
      }
      if (this.taxDataAccepted) {
        data.idCompanyDataStatus = status.ACEPTADO
        this.provider.idStage = stage.DATOS_IMPOSITIVOS
        this.provider.idUser = this.user.idUser
        data.idUser = this.user.idUser
      }
      if (this.taxDataRejected) {
        data.idCompanyDataStatus = status.DEVUELTO
        this.provider.idStage = stage.DATOS_IMPOSITIVOS
        this.provider.idUser = this.user.idUser
        data.observation = this.newObservation
        this.provider.idCompanyDataStatus = status.DEVUELTO
        data.idUser = this.user.idUser
        setTimeout(() => {
          api
            .request('GET', 'api/sendMailUserReject/' + this.provider.idCompany)
            .then(() => {})
        }, 900)
      }
      if (this.paymentDataAccepted) {
        data.idCompanyDataStatus = status.ACEPTADO
        this.provider.idCompanyStatus = status.ACEPTADO
        this.provider.idCompanyDataStatus = status.ACEPTADO
        setTimeout(() => {
          api
            .request(
              'GET',
              'api/sendMailUserActivation/' + this.provider.idCompany
            )
            .then(() => {})
        }, 900)
        this.provider.idUser = this.user.idUser
        data.idUser = this.user.idUser
      }
      if (this.paymentDataRejected) {
        data.idCompanyDataStatus = status.DEVUELTO
        data.observation = this.newObservation
        this.provider.idCompanyDataStatus = status.DEVUELTO
        setTimeout(() => {
          api
            .request('GET', 'api/sendMailUserReject/' + this.provider.idCompany)
            .then(() => {})
        }, 900)
        this.provider.idUser = this.user.idUser
        data.idUser = this.user.idUser
      }
      this.activationOrReject()
      //
      api
        .request(
          'POST',
          'api/generic/company/' + this.provider.idCompany,
          JSON.stringify(this.provider)
        )
        .then(() => {
          let idCompanyData
          switch (dataType) {
            case 'generalData':
              idCompanyData = this.provider.idCompany
              break
            case 'paymentData':
              idCompanyData = this.provider.idCompany
              break
            case 'taxData':
              idCompanyData = this.provider.idCompany
              break
          }
          this.$store.commit('START_LOADING')
          api
            .request(
              'POST',
              'api/generic/' + dataType + '/' + idCompanyData,
              JSON.stringify(data)
            )
            .then((response) => {
              switch (dataType) {
                case 'generalData':
                  this.provider.ruc = this.generalData.ruc
                  this.provider.company = this.generalData.company.model
                  this.provider.companyName = this.generalData.companyName.model
                  api
                    .request(
                      'POST',
                      'api/generic/company/' + this.provider.idCompany,
                      JSON.stringify(this.provider)
                    )
                  break
              }
              // this.rejectCompanyDataVisible = false
              // this.newObservation = ''
              this.$store.commit('STOP_LOADING')
              this.provider[dataType] = response.data

              this.user.roles.forEach((role) => {
                if (
                  role.rolesId === rolesText.AUTORIZADOR_DG_PE || role.rolesId === rolesText.ADMIN_SISTEMA || role.rolesId === rolesText.ADMIN_PORTAL
                ) {
                  this.$router.push('/newProviders')
                }
                if (
                  role.rolesId === rolesText.AUTORIZADOR_DI_PE || role.rolesId === rolesText.ADMIN_SISTEMA || role.rolesId === rolesText.ADMIN_PORTAL
                ) {
                  this.$router.push('/newProviders')
                }
                if (
                  role.rolesId === rolesText.AUTORIZADOR_DP_PE || role.rolesId === rolesText.ADMIN_SISTEMA || role.rolesId === rolesText.ADMIN_PORTAL
                ) {
                  this.$router.push('/newProviders')
                }
              })

              this.$message.success('Estado cambiado satisfactoriamente')
            })
            .catch((error) => {
              console.log(error)
              this.$store.commit('STOP_LOADING')
              // this.$message.danger('Error al cambiar el estado')
            })
        })
    },
    openRejectCompanyDataModal () {
      let permission = this.checkRoles(this.step)
      if (!permission) {
        console.log('Permision es :' + permission)
        this.$router.push('/newProviders')
        this.$alert(
          'No tiene los permisos requeridos para realizar esta accion',
          'Permisos Insuficientes',
          {
            confirmButtonText: 'Aceptar',
            callback: (action) => {
              this.$router.push('/newProviders')
            }
          }
          )
        return
      }
      this.rejectCompanyDataVisible = true
    },
    clearOptionalPaymentData (switchValue) {
      saveDataToLocalStorage(switchValue, 'paymentFlag')
      for (let key in this.paymentData2) {
        if (this.paymentData2.hasOwnProperty(key)) {
          this.paymentData2[key].model = ''
          saveDataToLocalStorage('', key)
        }
      }
    },
    rejectCompanyData (dataType) {
      if (this.newObservation === '') {
        this.$message.warning('Falta completar el motivo')
        return
      }
      this.$confirm(
        '¿Está seguro que desea rechazar los datos por este motivo?',
        'Advertencia',
        {
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }
      )
        .then(() => {
          if (dataType === 'generalData') {
            this.generalDataRejected = true
          }
          if (dataType === 'paymentData') {
            this.paymentDataRejected = true
          }
          if (dataType === 'taxData') {
            this.taxDataRejected = true
          }
          this.saveData(dataType)
          this.$router.push('/newProviders')
        })
        .catch(() => {})
    },
    openModalTerminosYCondiciones () {
      this.validateSteps()
      if (this.emptyFields.length === 0) {
        this.showTerminosYCondiciones = true
      }
    },
    submitFormSolicitud () {
      // localStorage.clear()
      this.solicitudActivarUsuario('1')
      if (this.checked2 && this.checked) {
        this.showTerminosYCondiciones = false
        this.checkData()
      } else {
        this.checked2 = false
        this.checked = false
        this.showTerminosYCondiciones = true
      }
    },
    solicitudActivarUsuario (stage = null) {
      const companyName = this.generalData.companyName.name
      const idFiscal = this.id.model
      const idType = this.idType
      if (!stage) {
        stage = this.provider.idStage
      }
      api
        .request(
          'GET',
          'api/solicitudActivarUsuario' + '?stage=' + stage + '&idFiscal=' + idFiscal + '&companyName=' + companyName + '&idType=' + idType
        )
        .then((response) => {
          this.toggleLoading()
        })
        .catch((error) => {
          this.$store.commit('TOGGLE_LOADING')
          this.invoices = null
          console.log(error)

          this.response =
            'Error al conectarse con el servidor, contacte al administrador.'
          this.toggleLoading()
        })
    },
    checkProviderData () {
      if (this.provider && this.idCompany) {
        this.loadProvider()
      }
    },
    checkRoles (currentStep) {
      let permission = false
      this.user.roles.forEach((role) => {
        console.log(role.rolesId)
        switch (role.rolesId) {
          case rolesText.AUTORIZADOR_DG_PE:
            if (currentStep === 0) {
              permission = true
            }
            break
          case rolesText.AUTORIZADOR_DI_PE:
            if (currentStep === 1) {
              permission = true
            }
            break
          case rolesText.AUTORIZADOR_DP_PE:
            if (currentStep === 2) {
              permission = true
            }
            break
          case rolesText.ADMIN_SISTEMA:
            permission = true
            break
          default:
            break
        }
      })
      return permission
    },
    activationOrReject () {
      // Condiciones simples para asignar el idCompanyCompanyDataStatus
      var genD = this.provider.generalData.idCompanyDataStatus
      var payD = this.provider.paymentData.idCompanyDataStatus
      var taxD = this.provider.taxData.idCompanyDataStatus

      if (
        genD === status.ACEPTADO &&
        payD === status.ACEPTADO &&
        taxD === status.ACEPTADO
      ) {
        this.provider.idCompanyDataStatus = status.ACEPTADO
        this.provider.idCompanyStatus = status.ACEPTADO
        setTimeout(() => {
          api
            .request(
              'GET',
              'api/sendMailUserActivation/' + this.provider.idCompany
            )
            .then(() => {})
        }, 900)
      } else {
        if (
          genD === status.DEVUELTO ||
          payD === status.DEVUELTO ||
          taxD === status.DEVUELTO
        ) {
          this.provider.idCompanyDataStatus = status.DEVUELTO
          this.provider.idCompanyStatus = status.RECHAZADO
          setTimeout(() => {
            api
              .request('GET', 'api/sendMailUserReject/' + this.provider.idCompany)
              .then(() => {})
          }, 900)
        }
      }
    },
    getBankAccountTypes () {
      api.request('GET', 'api/generic/bankAccountType')
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            const accountTypes = data.filter((bankAccountType) => bankAccountType.codCountry === 'PE')
            this.bankAccountTypes = data.filter((bankAccountType) => bankAccountType.codCountry === 'PE')
            this.paymentData1.accountType.optionValue = accountTypes.map((accountType) => accountType.bankAccountType)
            this.paymentData2.accountType2.optionValue = accountTypes.map((accountType) => accountType.bankAccountType)
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    acceptCompanyData (StepType) {
      let solicitud = true
      if (this.provider.idStage === '3') {
        solicitud = false
      }
      let permission = this.checkRoles(this.step)
      console.log('permission: ', permission)
      if (!permission) {
        console.log('Permision es :' + permission)
        this.$router.push('/newProviders')
        this.$alert(
          'No tiene los permisos requeridos para realizar esta accion',
          'Permisos Insuficientes',
          {
            confirmButtonText: 'Aceptar',
            callback: (action) => {
              this.$router.push('/newProviders')
            }
          }
        )
        return
      }
      this.$confirm(
        '¿Está seguro que desea aceptar los datos?',
        'Advertencia',
        {
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }
      )
        .then(() => {
          // this.provider[StepType] = StepType
          if (StepType === 'generalData') {
            this.generalDataAccepted = true
          }
          if (StepType === 'paymentData') {
            this.paymentDataAccepted = true
          }
          if (StepType === 'taxData') {
            this.taxDataAccepted = true
          }

          // this.provider[dataType].idUser = this.user.idUser
          // this.provider.signUpStatus++
          this.saveData(StepType)
          if (solicitud) {
            this.solicitudActivarUsuario()
          }
          this.$parent.getProviders()
          if (!this.checkRoles(this.step + 1)) {
            this.$router.push('/newProviders')
          }
          this.$router.push('/newProviders')
        })
        .catch(() => {})
    }
  },
  beforeMount () {
    this.isSystemAdmin()
    this.idCompany = this.$route.params.id
    this.actualCountry = this.$route.params.country
    this.companyData()
  },
  mounted () {
    console.log(this.user)
    this.getBankAccountTypes()
    this.checkProviderData()
    this.getRubros()
    this.getLocations()
    this.getDenomination()
    this.getBank()
    // RUC
    this.recoverFromNewProviderStorage(this.id, 'id')
    // GENERAL DATA
    for (const key in this.generalData) {
      this.recoverFromNewProviderStorage(this.generalData, key)
    }
    // TAX DATA
    for (const key in this.companyTaxData) {
      this.recoverFromNewProviderStorage(this.companyTaxData, key)
    }
    // PAYMENT DATA
    for (const key in this.paymentData1) {
      this.recoverFromNewProviderStorage(this.paymentData1, key)
    }
    this.recoverFromNewProviderStorage(this.optionalPaymentFlag, 'paymentFlag')
    for (const key in this.paymentData2) {
      this.recoverFromNewProviderStorage(this.paymentData2, key)
    }
    for (const key in this.paymentData3) {
      this.recoverFromNewProviderStorage(this.paymentData3, key)
    }
    // USER DATA
    for (const key in this.userData) {
      this.recoverFromNewProviderStorage(this.userData, key)
    }
    api
      .request('get', 'api/findConfiguration/TYC')
      .then((response) => {
        this.configuration = response.data['value']
      })
      .catch((error) => {
        console.log(error)
      })
    api
      .request('get', 'api/findConfiguration/CODETI')
      .then((response) => {
        this.codigoEtica = response.data['value']
      })
      .catch((error) => {
        console.log(error)
      })
    api
      .request('get', 'api/findConfiguration/POLANTI')
      .then((response) => {
        this.politicaAnticorrupcion = response.data['value']
      })
      .catch((error) => {
        console.log(error)
      })
    api
      .request('get', 'api/findConfiguration/POLREL')
      .then((response) => {
        this.politicaRelacionamiento = response.data['value']
      })
      .catch((error) => {
        console.log(error)
      })
  }
}
</script>

<style>
body {
  background-color: #ecf0f5;
}

el-input {
  width: 400px;
}
.card-header{
  display: flex;
  font-weight: 400;
  font-size: 18px;
  margin-top:-8px;
  margin-bottom: -20px;
}
.back-btn{
  width: 100%;
  display: flex;
  justify-content: end;
  margin: 30px 0;
}
.box-card{
  border-top: 3px solid #00c0ef;
  margin-left: -90px;
  margin-bottom: 30px;
}
.email__consultas-container{
  font-size: 13px;
  font-weight: 400;
  padding-bottom: 10px;
  margin-bottom: -20px;
  text-align: center;
  display:flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// ConfirmProviderPeru.vue?0accd157